import React, { useEffect, useState } from "react";
import { logout } from "../Utils/AuthService";
import { useNavigate } from "react-router-dom";

import { AppProvider } from "@toolpad/core/AppProvider";
import { DashboardLayout } from "@toolpad/core/DashboardLayout";
import Grid from "@mui/material/Grid2";
import { useSelector, useDispatch } from "react-redux";
import { useMediaQuery, useTheme } from "@mui/material";
import { fetchFeatures, resetAppState } from "../../redux/slices/appSlice";
import { getCompany } from "../../redux/slices/superAdmin/companiesSlice";
import { enableFeature } from "../../redux/slices/appSlice";
import { fetchLanguages } from "../../redux/slices/superAdmin/languagesSlice";
import Banner from "../../components/Utils/Snackbar";
import { getConfig } from "../../redux/slices/appSlice";
import {
  buildNavigation,
  renderContent,
} from "../Pages/OrgAdmin/Utils/NavigationUtils";
import {
  SidebarFooter,
  demoTheme,
  CustomAppTitle,
  useDemoRouter,
} from "./Theme";

import defaultAdmin from "../../Assets/profile.png";

import StopImpersonate from "../Pages/OrgAdmin/Components/StopImpersonate";

export default function DashboardLayoutBasic(props) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isDesktop = useMediaQuery("(min-width:1200px) and (max-width:1600px)");
  const isLargeDesktop = useMediaQuery(
    "(min-width:1600px) and (max-width:2400px)"
  );

  const gridWidth = isMobile
    ? "100vw"
    : isLargeDesktop
      ? "85vw"
      : isDesktop
        ? "79vw"
        : "100vw";
  const router = useDemoRouter("/dashboard");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { isImpersonating, companyId } = useSelector((state) => state.app);
  const { firstName, email } = useSelector((state) => state.user.userInfo);

  const features = useSelector((state) => state.app.features);
  const config = useSelector((state) => state.app.config);
  const { languagesList } = useSelector((state) => state.languages);

  const [data, setData] = useState([]);

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  useEffect(() => {
    if (features === null) {
      dispatch(fetchFeatures());
    }
    if (config === null) {
      dispatch(getConfig());
    }
    dispatch(getConfig());
  }, [dispatch, features, companyId]);

  useEffect(() => {
    if (!languagesList?.length) {
      dispatch(fetchLanguages({ companyId }));
    }
  }, [dispatch, languagesList?.length, companyId]);

  useEffect(() => {
    const fetchCompanyDetails = async () => {
      try {
        const result = await dispatch(getCompany(companyId || 2)).unwrap();
      } catch (error) {
        console.error("Failed to fetch company details:", error);
      }
    };

    if (companyId) {
      fetchCompanyDetails();
    }
  }, [dispatch, companyId]);

  const [session, setSession] = React.useState({
    user: {
      name: firstName || "Elio",
      email: email || "elio.mouhasseb3@gmail.com",
      image: defaultAdmin,
    },
  });

  const authentication = React.useMemo(() => {
    return {
      signOut: () => {
        handleLogout();
        dispatch(resetAppState());
      },
    };
  }, []);

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  const toggleFeature = (id, updatedEnabledState) => {
    dispatch(
      enableFeature({
        featureId: id,
        enabled: updatedEnabledState ? 1 : 0,
      })
    )
      .then((result) => {
        if (result.meta.requestStatus === "fulfilled") {
          dispatch(fetchFeatures());
          const updatedData = data?.map((item) =>
            item.id === id ? { ...item, isActive: updatedEnabledState } : item
          );
          setData(updatedData);
          setSnackbarMessage("Feature updated successfully!");
          setSnackbarSeverity("success");
          setSnackbarOpen(true);
        } else {
          throw new Error("Failed to toggle feature.");
        }
      })
      .catch((error) => {
        setSnackbarOpen(true);
        setSnackbarMessage(
          error.message || "Unexpected error occurred. Please contact support."
        );
        setSnackbarSeverity("error");
      });
  };

  return (
    <>
      <AppProvider
        navigation={buildNavigation(features, isImpersonating, toggleFeature)}
        router={router}
        theme={demoTheme}
        session={session}
        authentication={authentication}
      >
        <DashboardLayout
          style={{
            margin: 0,
            padding: 0,
            width: "100vw",
            height: "100vh",
            boxSizing: "border-box",
          }}
          slots={{
            appTitle: CustomAppTitle,
            sidebarFooter: SidebarFooter,
          }}
        >
          <Grid
            container
            spacing={0}
            style={{
              width: gridWidth,
              height: "100vh",
              margin: 0,
              padding: 0,
            }}
          >
            <Grid
              item
              xs={12}
              style={{
                width: "100%",
                margin: 0,
                padding: 0,
              }}
            >
              {renderContent(router.pathname, handleLogout)}
            </Grid>
          </Grid>

          {isImpersonating && <StopImpersonate />}
        </DashboardLayout>
      </AppProvider>
      <Banner
        open={snackbarOpen}
        message={snackbarMessage}
        severity={snackbarSeverity}
        handleClose={() => setSnackbarOpen(false)}
      />
    </>
  );
}
